import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import { BiContextProvidedValue, BiData, DefaultBiEvent } from '@wix/da-bi/pkg/events';
import CommentIcon from '@wix/da-ds/pkg/Icons/24x24/Comment';
import Stat, { Props as StatProps } from './Stat';
import useDeviationStats from './useDeviationStats';

export interface Props extends Omit<StatProps, 'statNameLocaleKey'> {
  deviation: PapiDeviation;
  className?: string;
  /** don't display language after stat count */
  onlyNumbers?: boolean;
  /** should display tooltip list of users that have commented */
  withUserList?: boolean;
}

const CommentStat: React.FC<Props> = ({
  deviation,
  onlyNumbers,
  withUserList = true,
  className,
  ...baseProps
}) => {
  const { t } = useTranslation();
  const { comments, isCommentable } = useDeviationStats(deviation);

  return !isCommentable ? null : (
    <Stat
      className={className}
      deviation={deviation}
      statCount={comments}
      icon={CommentIcon}
      onlyNumbers={onlyNumbers}
      userListType={withUserList ? 'comment' : undefined}
      statNameLocaleKey="deviation.stats.comments"
      title={t('deviation.stats.tooltip.comments')}
      biData={BiData<DefaultBiEvent>({
        evid: 2,
        click_info: 'comments',
        sectionname: BiContextProvidedValue,
        widgetname: BiContextProvidedValue,
        typeid: BiContextProvidedValue,
        itemid: BiContextProvidedValue,
      })}
      {...baseProps}
    />
  );
};
CommentStat.displayName = 'CommentStat';

export default CommentStat;
